var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('book-mark-5'),_c('vietnam-thai-1'),_c('book-mark-6'),_c('book-mark-4-4'),_c('modal-component'),_c('book-mark-8')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }